module.exports ={
  null: ['暂无数据','N/A'],
  detail: {
    title: ['手续费明细','Fee Details'],
    all: ['全部','all'],
    transactionType_label: ['交易类型：','Transaction type：'],
    sourceTrace_label: ['商户订单号：','Merchant order number：'],
    sourceTrace_placeholder: ['商户订单号','Merchant order number'],
    trans_currency_label: ['交易币种：','Trading currency：'],
    transactionNumber_label: ['平台订单号：','Platform order number：'],
    transactionNumber_placeholder: ['平台订单号','Platform order number'],
    fee_status_label: ['商户手续费状态：','Merchant Fee Status：'],
    trans_date_label: ['原交易完成时间：','Original Transaction Time：'],
    start_date: ['开始日期','Start Date'],
    end_date: ['结束日期','End Date'],
    to: ['至','To'],
    search: ['查询','Inquiry'],
    reset: ['重置','Reset'],
    trans_fee_title: ['交易手续费明细','Transaction fee details'],
    export: ['导出','Export'],
    merchantName: ['商户名称','Merchant name'],
    sourceTrace: ['商户订单号','Merchant order number'],
    transactionNumber: ['平台订单号','Platform order number'],
    transactionType: ['交易类型','Transaction type'],
    transactionFinishedTime: ['交易完成时间','Transaction Completion Time'],
    trans_currency: ['交易币种','Trading currency'],
    transactionAmount: ['交易金额','Transaction amount'],
    calculateUnit: ['商户手续费周期','Merchant fee cycle'],
    fee_amount: ['商户手续费金额','Merchant fee amount'],
    fee_status: ['商户手续费状态','Merchant fee status'],
    fee: ['手续费', 'Fee'],
    export_file_error: ['请稍后重试', 'Try again later'],
  },
  reconciliation: {
    title: ['手续费对账','Fee Reconciliation'],
    monthRegion_label: ['交易月份：','Transaction Month：'],
    monthRegionFrom: ['开始月份','Start Month'],
    monthRegionTo: ['结束月份','End Month'],
    to: ['至','To'],
    all: ['全部','all'],
    trans_type_label: ['交易类型：','Transaction type：'],
    trans_currency_label: ['交易币种：','Trading currency：'],
    merchant_status_label: ['状态：','State：'],
    search: ['查询','Inquiry'],
    reset: ['重置','Reset'],
    trans_fee_title: ['交易手续费对账','Transaction fee reconciliation'],
    export: ['导出','Export'],
    trans_type: ['交易类型','Transaction type'],
    monthRegion: ['交易月份','Transaction Month'],
    calculateUnit: ['商户手续费周期','Merchant fee cycle'],
    totalSize: ['交易笔数','Number of transactions'],
    trans_amount: ['交易金额','Transaction amount'],
    currency: ['币种','currency'],
    feeAmount: ['手续费金额','Fee amount'],
    merchantStatus: ['商户手续费状态','Merchant fee status'],
    operate: ['操作','Operate'],
    confirm_fee: ['确认手续费','Confirm Fee'],
    detail: ['明细','Details'],
    confirm_fee_title: ['商户手续费确认','Merchant fee confirm'],
    total_feeSize: ['共计手续费笔数','total fee NO'],
    total_feeAmount: ['共计手续费金额','total fee amount'],
    cancel: ['取 消','cancel'],
    submit: ['确 定','submit'],
    confirm_fee_txt: ['确定要确认该条手续费吗?','Are you sure to confirm this fee item?'],
    tips: ['提示','Tips'],
    confirm_fee_success: ['手续费确认成功','Fee confirm succeeded'],
    export_file_error: ['请稍后重试', 'Try again later'],
  }
  
}